import React, { useMemo } from 'react';
import { QuestionnaireResult } from '../../../../../graphql/graphql';
import DataTable, {
	DataTableColumn,
} from '../../../../Base/Components/DataTable/DataTable';
import {
	ACER_SCORE_LEVEL_COLORS,
	AcerGroupScoreRow,
	getAcerGroupScores,
	getAcerScoreLevel,
} from '../Helpers/QuestionnaireResultsWithScoringListItem.helper';

interface Props {
	item: QuestionnaireResult;
}

const QuestionnaireResultsWithScoringListItemDetailedScoring: React.FC<
	Props
> = ({ item }) => {
	const groupScores = useMemo(() => getAcerGroupScores(item), [item]);

	const columns = useMemo<DataTableColumn<AcerGroupScoreRow, undefined>[]>(
		() => [
			{
				key: 'title',
				label: 'Skupina',
				visible: true,
				renderItem: row => row.title,
			},
			{
				key: 'score',
				label: 'Body',
				visible: true,
				renderItem: row => {
					const percent =
						row.maxScore > 0 ? (row.score / row.maxScore) * 100 : 0;

					const backgroundColor =
						ACER_SCORE_LEVEL_COLORS[getAcerScoreLevel(percent)];

					return (
						<div
							style={{
								backgroundColor,
								color: '#ffffff',
								fontWeight: 600,
								padding: '5px 10px',
								borderRadius: 15,
								display: 'inline-block',
								minWidth: 48,
								textAlign: 'center',
							}}>
							{row.score}
						</div>
					);
				},
			},
			{
				key: 'maxScore',
				label: 'Max. body',
				visible: true,
				renderItem: row => row.maxScore,
			},
		],
		[],
	);

	return (
		<DataTable<AcerGroupScoreRow, undefined>
			data={groupScores}
			table={undefined}
			columns={columns}
		/>
	);
};

export default QuestionnaireResultsWithScoringListItemDetailedScoring;
